import React from 'react'
import { useHistory } from 'react-router-dom'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ClientsIcon from '../images/client-black.svg'
import AdminActive from '../images/admin-white.svg'
import Admin from '../images/admin-black.svg'
import ClientsActive from '../images/client-white.svg'
import DashboardActive from '../images/gestione-ordini-white.svg'
import Dashboard from '../images/gestione-ordini-black.svg'
import AgentBlack from '../images/agent-black.svg'
import AgentWhite from '../images/agent-white.svg'
import ListItemText from '@material-ui/core/ListItemText'
import ListSubheader from '@material-ui/core/ListSubheader'
import ProductsActive from '../images/catalogo-prodotti-white.svg'
import Products from '../images/catalogo-prodotti-black.svg'
import AssignmentIcon from '@material-ui/icons/Assignment'
import { getRoleUserIdFromToken } from '../utils'
import { Divider } from '@mui/material'

export const mainListItems = () => {
  const history = useHistory()
  const roleUserId = getRoleUserIdFromToken()

  return (<div style={{margin:'0 0.5rem'}}>
    <ListItem button style={{marginTop:'0.5rem', backgroundColor:['/dashboard'].includes(location.pathname) ?'black' :'white', borderRadius:'8px'}} onClick={() => history.push('/dashboard')}>
      <ListItemIcon>
      <img src={['/dashboard'].includes(location.pathname) ? DashboardActive : Dashboard}/>
      </ListItemIcon>
      <ListItemText style={['/dashboard'].includes(location.pathname) ? { color: 'white' } : { color: 'black' }} primary="Gestione ordini" />
    </ListItem>
    <ListItem button style={{marginTop:'0.5rem', backgroundColor:['/products'].includes(location.pathname) ?'black' :'white', borderRadius:'8px'}} onClick={() => history.push('/products')}>
      <ListItemIcon>
      <img src={['/products'].includes(location.pathname) ? ProductsActive : Products}/>
      </ListItemIcon>
      <ListItemText style={['/products'].includes(location.pathname) ? { color: 'white' } : { color: 'black' }} primary="Catalogo prodotti" />
    </ListItem>
    <ListItem button style={{marginBottom:roleUserId === 2 && '1rem', marginTop:'0.5rem', backgroundColor:['/clients'].includes(location.pathname) ?'black' :'white', borderRadius:'8px'}} onClick={() => history.push('/clients')}>
      <ListItemIcon>
        <img src={['/clients'].includes(location.pathname) ? ClientsActive : ClientsIcon}/>
      </ListItemIcon>
      <ListItemText style={['/clients'].includes(location.pathname) ? { color: 'white' } : { color: 'black' }} primary="Lista clienti" />
    </ListItem>
    
    {roleUserId === 1 && <ListItem button style={{marginBottom:'1rem', marginTop:'0.5rem', backgroundColor:['/agents'].includes(location.pathname) ?'black' :'white', borderRadius:'8px'}} onClick={() => history.push('/agents')}>
        <ListItemIcon>
          <img src={['/agents'].includes(location.pathname) ? AgentWhite : AgentBlack}/>
        </ListItemIcon>
        <ListItemText style={['/agents'].includes(location.pathname) ? { color: 'white' } : { color: 'black' }} primary="Lista agenti" />
      </ListItem>
      }
    <Divider />
    <ListItem button style={{marginTop:'1rem', backgroundColor:['/admin'].includes(location.pathname) ?'black' :'white', borderRadius:'8px' }} onClick={() => history.push('/admin')}>
      <ListItemIcon>
        <img src={['/admin'].includes(location.pathname) ? AdminActive : Admin}/>
      </ListItemIcon>
      <ListItemText style={['/admin'].includes(location.pathname) ? { color: 'white' } : { color: 'black' }} primary="Admin" />
    </ListItem>
  </div>
  )
}

export const secondaryListItems = (
  <div>
    <ListSubheader inset>Saved reports</ListSubheader>
    <ListItem button>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Current month" />
    </ListItem>
    <ListItem button>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Last quarter" />
    </ListItem>
    <ListItem button>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Year-end sale" />
    </ListItem>
  </div>
)